import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "22 7 13.5 15.5 8.5 10.5 2 17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 7 22 7 22 13", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "TrendingUp";
const TrendingUp = memo(themed(Icon));
export {
  TrendingUp
};
//# sourceMappingURL=trending-up.js.map
